import {
  WORKER_CONFIG_LOGIN_BEGIN,
  WORKER_CONFIG_LOGIN_SUCCESS,
  WORKER_CONFIG_LOGIN_FAILURE,
  WORKER_CONFIG_LOGIN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import moment from 'moment';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function login(code, redirectUri) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WORKER_CONFIG_LOGIN_BEGIN,
    });

     const promise = new Promise((resolve, reject) => {
      axios.get("/api/session/login?code="+encodeURIComponent(code)+"&redirectUri="+encodeURI(redirectUri))
      .then(
        (res) => {
          dispatch({
            type: WORKER_CONFIG_LOGIN_SUCCESS,
            data: {res,code}
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: WORKER_CONFIG_LOGIN_FAILURE,
            data: { error: err, code },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoginError() {
  return {
    type: WORKER_CONFIG_LOGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_LOGIN_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loginPending: true,
        loginError: null,
      };

    case WORKER_CONFIG_LOGIN_SUCCESS:
      // The request is success
      return {
        ...state,
        triedCodes: {...state.triedCodes, [action.data.code]:true},
        loginPending: false,
        loginError: null,
      };

    case WORKER_CONFIG_LOGIN_FAILURE:
      // The request is failed
      return {
        ...state,
        triedCodes: {...state.triedCodes, [action.data.code]:true},
        loginPending: false,
        loginError: action.data.error,
      };

    case WORKER_CONFIG_LOGIN_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loginError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/login.js